

import React from 'react';

import './style.css'


interface IModalProps {
    icon : string,
    message: string,
    isOpen: boolean,
    onClose: () => void
}

const MessageModal: React.FC<IModalProps> = ({message, icon, isOpen = false, onClose  }) => {


    if (!isOpen) {
        return null;
      }
    
      return (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className='center-middle'>
                <div className="icon-size-2">
                    <img className="responsive-image" src={icon} />
                </div>
            </div>
            <br />
            <div className='center-middle font-size-17px'>
               {message}
            </div>
            <br />
            <div className="center-middle">
                <button type="button" className='btn-green-2 center-middle' onClick={onClose} >Ok</button>
            </div>
          </div>
        </div>
      );

}

export default MessageModal;